export const FILTER_TYPE_CODE = {
    MULTIPART: 'multipart',
    SUBTYPE: 'subtype'
}

export const CONTENT_RATING = {
    PG_13: "PG-13",
    A: "A"
}